import { VFC, memo } from 'react';
import { Button } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      borderTop: '2px solid #f5f5f5',
      backgroundColor: '#FFFFFF',
      position: 'fixed',
      bottom: 0,
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      padding: 20,
      marginLeft: -15
    },
    save: {
      marginRight: 30,
      marginBottom: 0,
      backgroundColor: '#52555F'
    },
    preview: {
      marginRight: 15,
      marginBottom: 0,
      backgroundColor: '#52555F'
    }
  })
);

type Props = {
  id: string;
  edit: boolean;
  createFunc: (goPreview: boolean) => void;
  updateFunc: (goPreview: boolean) => void;
};

const SaveButtonField: VFC<Props> = props => {
  const { id, edit, createFunc, updateFunc } = props;
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div>
        {id && (
          <Button
            className={classes.preview}
            variant='contained'
            color='primary'
            onClick={() => (edit ? updateFunc(true) : createFunc(true))}
          >
            プレビュー
          </Button>
        )}

        <Button
          className={classes.save}
          variant='contained'
          color='primary'
          onClick={() => (edit ? updateFunc(false) : createFunc(false))}
        >
          保存
        </Button>
      </div>
    </div>
  );
};

export default memo(SaveButtonField);
